import axios from 'axios'
class LoggerService {
    async logger (payload) {
        const loggerUrl = process.env.VUE_APP_LOGGER
        const response = await axios.post(loggerUrl, JSON.stringify(payload))
        return response
    }
}
export default new LoggerService()
